import script from "./companysettings.vue?vue&type=script&setup=true&lang=js"
export * from "./companysettings.vue?vue&type=script&setup=true&lang=js"

import "./companysettings.vue?vue&type=style&index=0&id=56be3e46&lang=css"

const __exports__ = script;

export default __exports__